import { type PlaybookRunFragment, usePlaybookRunsChangedSubscription, usePlaybookRunsQuery } from "@qw/graphql";
import { useCallback } from "react";

const POLL_FALLBACK_MS = 30_000;

export interface UsePlaybookRunTreeResult {
  isLoading: boolean;
  playbookRuns: PlaybookRunFragment[];
  refetchPlaybookRuns: () => void;
}

export const usePlaybookRunTree = (
  rootChatSessionId: string | undefined,
  enabled: boolean
): UsePlaybookRunTreeResult => {
  const { data, loading, refetch } = usePlaybookRunsQuery({
    variables: { chatSessionId: rootChatSessionId },
    skip: !enabled || !rootChatSessionId,
    fetchPolicy: "cache-and-network",
    pollInterval: POLL_FALLBACK_MS,
    skipPollAttempt: () => typeof document !== "undefined" && document.visibilityState === "hidden",
  });

  const refetchPlaybookRuns = useCallback(() => {
    if (enabled && rootChatSessionId) {
      void refetch();
    }
  }, [enabled, refetch, rootChatSessionId]);

  usePlaybookRunsChangedSubscription({
    variables: { chatSessionId: rootChatSessionId },
    skip: !enabled || !rootChatSessionId,
    onData: refetchPlaybookRuns,
  });

  return {
    isLoading: enabled && loading,
    playbookRuns: enabled ? (data?.playbookRuns ?? []) : [],
    refetchPlaybookRuns,
  };
};
